import React, { useState } from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'

import { Observer } from 'mobx-react'
import { useStores } from 'config/store'
import Select from './Select'
import FilterModal from './FilterModal'
import AccountList from './AccountList'

const AccountFilter = () => {
  const { notificationSettingsStore } = useStores()
  const classes = useStyle()
  const [isOpen, setIsOpen] = useState(false)

  const handleOpenModal = () => {
    if (notificationSettingsStore.isUpdating) {
      alert('Selecting a different account will discard unsaved changes.')
    }
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  const handleApply = () => {
    notificationSettingsStore.setApplySelectedAccount(true)
    setIsOpen(false)
  }

  return (
    <Observer
      render={() => {
        const label = notificationSettingsStore.accounts.find(
          (account: {
            id: string
            name: string
          }) =>
            account.id === notificationSettingsStore.selectedAccount
        )?.name || 'No account selected'
        return (
          <div className={classes.root}>
            <Select label={label} onClick={handleOpenModal} isOpened={isOpen} />
            <FilterModal
              title="Select account"
              isOpen={isOpen}
              onClose={handleClose}
              applyCallback={handleApply}
            >
              <AccountList />
            </FilterModal>
          </div>
        )
      }}
    />
  )
}

export default AccountFilter

const useStyle = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    padding: '1rem 0 0.3rem',
    gap: '.5rem',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      alignItems: 'center',
      padding: '0',
    },
  },
}))
